import ShippingMethodListItem from './ShippingMethodListItem'
import {FC, useEffect, useState} from 'react'
import Pagination from 'app/components/pagination'

type Props = {
  deliveryMethod: any
}
const pageSize = 5
const ShippingMethodList: FC<Props> = ({deliveryMethod}) => {
  const totalCount = deliveryMethod.length
  const [currentPage, setCurrentPage] = useState(1)
  useEffect(() => {})
  const handlePageChange = (currentPage: any) => {
    setCurrentPage(currentPage)
  }

  const lastIndex = pageSize * currentPage
  const firstIndex = lastIndex - pageSize
  if (deliveryMethod) {
    return (
      <div>
        {deliveryMethod.slice(firstIndex, lastIndex).map((rate: any) => (
          <ShippingMethodListItem key={rate.rateClassId} deliveryMethod={rate} />
        ))}
        <Pagination
          totalCount={totalCount}
          onPageChange={handlePageChange}
          currentPage={currentPage}
          pageSize={pageSize}
        />
      </div>
    )
  }
  return null
}

export default ShippingMethodList
